import React from 'react';
import PropTypes from 'prop-types';

import BaseInput from './BaseInput';

const SelectWidget = props => {
  const { value, options: { enumOptions } } = props;
  const matchedOptions = enumOptions.filter(opt => opt.value.toString() === value);
  const displayValue = matchedOptions.length > 0 ? matchedOptions[0].label : null;
  return <BaseInput {...props} value={displayValue} />;
};

SelectWidget.propTypes = {
  options: PropTypes.any,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SelectWidget;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/widgets/readonly/SelectWidget.js